export default __webpack_public_path__ + "static/media/motion-on-large@2x.fde5e60b.png";